import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { IconButton, Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import Logo from '../logo.png';
import { Link } from 'react-scroll';

const ToggleButton = styled(IconButton)`
  color: inherit;
  margin-left: auto;
`;

const FullPageMenu = styled(Drawer)`
  .MuiDrawer-paper {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.22);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(8.1px);
    -webkit-backdrop-filter: blur(8.1px);
    z-index: 1000;
  }
`;

const Header = ({ darkMode, onToggleDarkMode, onClose }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  });

  const isSticky = (e) => {
    const header = document.querySelector('.header-section');
    const scrollTop = window.scrollY;
    scrollTop >= 250
      ? header.classList.add('is-sticky')
      : header.classList.remove('is-sticky');
  };

  return (
    <div className="header header-section d-none d-xl-block">
      <div className="header-container">
        <div className="logo">
          <a href="/">
            <img src={Logo} alt="Logo" />
          </a>
        </div>
        <div className="hamburger-menu">
          <ToggleButton onClick={toggleMenu}>
            <MenuIcon className={darkMode ? 'dark-mode-nav' : ''} />
          </ToggleButton>
          <div className="dark-mode-switch">
            <IconButton onClick={onToggleDarkMode} color="primary">
              {darkMode ? <Brightness4Icon /> : <WbSunnyIcon />}
            </IconButton>
          </div>
          <FullPageMenu open={menuOpen} onClose={handleMenuClose}>
            <IconButton
              style={{ position: 'absolute', top: '10px', right: '10px' }}
              onClick={handleMenuClose}
            >
              <CloseIcon />
            </IconButton>
            <nav className="mobile-menu-nav">
              <Link
                to="about"
                smooth={true}
                duration={500}
                offset={-100}
                onClick={handleMenuClose}
              >
                About
              </Link>
              <Link
                to="projects"
                smooth={true}
                duration={500}
                offset={-100}
                onClick={handleMenuClose}
              >
                Projects
              </Link>
              <Link
                to="skills"
                smooth={true}
                duration={500}
                offset={-100}
                onClick={handleMenuClose}
              >
                Skills
              </Link>
              <Link
                to="contact"
                smooth={true}
                duration={500}
                offset={-100}
                onClick={handleMenuClose}
              >
                Contact
              </Link>
            </nav>
          </FullPageMenu>
        </div>
        {!menuOpen && (
          <nav>
            <Link
              to="about"
              smooth={true}
              duration={500}
              offset={-100}
              className={darkMode ? 'dark-mode-nav' : ''}
            >
              About
            </Link>
            <Link
              to="projects"
              smooth={true}
              duration={500}
              offset={-100}
              className={darkMode ? 'dark-mode-nav' : ''}
            >
              Projects
            </Link>
            <Link
              to="skills"
              smooth={true}
              duration={500}
              offset={-100}
              className={darkMode ? 'dark-mode-nav' : ''}
            >
              Skills
            </Link>
            <Link
              to="contact"
              smooth={true}
              duration={500}
              offset={-100}
              className={darkMode ? 'dark-mode-nav' : ''}
            >
              Contact
            </Link>
            <div className="dark-mode-switch">
              <IconButton onClick={onToggleDarkMode} color="primary">
                {darkMode ? <Brightness4Icon /> : <WbSunnyIcon />}
              </IconButton>
            </div>
          </nav>
        )}
      </div>
    </div>
  );
};

export default Header;
